import { render } from "./ImportEquipment.vue?vue&type=template&id=2b54adfb"
import script from "./ImportEquipment.vue?vue&type=script&lang=js"
export * from "./ImportEquipment.vue?vue&type=script&lang=js"

import "./ImportEquipment.vue?vue&type=style&index=0&id=2b54adfb&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__